module.exports = __webpack_public_path__ + "static/media/lightning.fc2ba1e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/lightning.svg
// module id = 967
// module chunks = 0